module.exports = __webpack_public_path__ + "static/media/warning.ace0514a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/warning.svg
// module id = 975
// module chunks = 0